import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import ErrorIcon from '@mui/icons-material/Error';

const dialogIcons = {
  question: <HelpIcon color="primary" fontSize="large" />,
  information: <InfoIcon color="info" fontSize="large" />,
  error: <ErrorIcon color="error" fontSize="large" />,
};

const buttonConfigs = {
  'yes-no': ['Yes', 'No'],
  'ok-cancel': ['OK', 'Cancel'],
  'cancel-delete': ['Cancel', 'Delete'],
  ok: ['OK'],
};

export default function ModalDialog({ open, title, body, type, buttonType, onClose }) {
  const buttons = buttonConfigs[buttonType] || ['OK'];
  const content = (typeof body === 'string' || typeof body === 'number')
    ? <Typography>{body}</Typography>
    : body;

  return (
    <Dialog open={open} onClose={() => onClose(null)}>
      <DialogTitle>
        <Stack direction="row" spacing={1} alignItems="center">
          {dialogIcons[type]}
          <Typography variant="h6">{title}</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        {content}
      </DialogContent>
      <DialogActions>
        {buttons.map((label) => (
          <Button key={label} onClick={() => onClose(label)}>
            {label}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
}
